import { render, staticRenderFns } from "./checkProfessionalIdentification.view.vue?vue&type=template&id=749a4bf1"
import script from "./checkProfessionalIdentification.view.vue?vue&type=script&lang=js"
export * from "./checkProfessionalIdentification.view.vue?vue&type=script&lang=js"
import style0 from "./checkProfessionalIdentification.view.vue?vue&type=style&index=0&id=749a4bf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports